import { c as _c } from "react/compiler-runtime";
import { ReactElement, RefObject, useEffect, useRef } from 'react';
import styles from './video-section.component.module.scss';
interface Props {
  readonly active?: boolean;
  readonly aspectRatio?: number;
  readonly autoplay?: boolean;
  readonly controls?: boolean;
  readonly url: string;
}
function VideoSectionComponent(t0) {
  const $ = _c(16);
  const {
    active: t1,
    aspectRatio: t2,
    autoplay: t3,
    controls: t4,
    url
  } = t0;
  const active = t1 === undefined ? true : t1;
  const aspectRatio = t2 === undefined ? 1 : t2;
  const autoplay = t3 === undefined ? false : t3;
  const controls = t4 === undefined ? false : t4;
  const videoRef = useRef(null);
  const aspectRatioCalculation = aspectRatio * 100;
  let t5;
  let t6;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      if (videoRef.current) {
        videoRef.current.load();
      }
    };
    t6 = [];
    $[0] = t5;
    $[1] = t6;
  } else {
    t5 = $[0];
    t6 = $[1];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[2] !== active) {
    t7 = () => {
      if (!active) {
        videoRef.current?.pause();
      }
    };
    t8 = [active];
    $[2] = active;
    $[3] = t7;
    $[4] = t8;
  } else {
    t7 = $[3];
    t8 = $[4];
  }
  useEffect(t7, t8);
  let t9;
  if ($[5] !== aspectRatioCalculation) {
    t9 = aspectRatioCalculation.toFixed(2);
    $[5] = aspectRatioCalculation;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  const t10 = `${t9}%`;
  let t11;
  if ($[7] !== t10) {
    t11 = {
      paddingBottom: t10
    };
    $[7] = t10;
    $[8] = t11;
  } else {
    t11 = $[8];
  }
  let t12;
  if ($[9] !== autoplay || $[10] !== controls || $[11] !== url) {
    t12 = <video ref={videoRef} className={styles["video-section__video"]} src={url} controls={controls} autoPlay={autoplay} tabIndex={-1} aria-hidden={true} />;
    $[9] = autoplay;
    $[10] = controls;
    $[11] = url;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== t11 || $[14] !== t12) {
    t13 = <span className={styles["video-section"]} style={t11}>{t12}</span>;
    $[13] = t11;
    $[14] = t12;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  return t13;
}
export default VideoSectionComponent;